/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./MainNavigation.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-mainNavigation");
var MainNavigation = /** @class */ (function (_super) {
    tslib_1.__extends(MainNavigation, _super);
    function MainNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainNavigation.prototype.render = function () {
        var _a = this.props, activeItem = _a.activeItem, children = _a.children;
        return (React.createElement("nav", { className: moduleClassName(), role: "navigation" },
            React.createElement("ul", { role: "menubar" }, React.Children.map(children, function (child) {
                var castedChild = child;
                if (!castedChild) {
                    return castedChild;
                }
                return (React.createElement("li", null, React.cloneElement(castedChild, {
                    "aria-selected": castedChild.props["data-name"] === activeItem,
                    className: classnames(castedChild.props.className, castedChild.props["data-name"] === activeItem
                        ? moduleClassName("isActive")
                        : undefined)
                })));
            }))));
    };
    MainNavigation.propTypes = {
        activeItem: PropTypes.any
    };
    return MainNavigation;
}(React.Component));
exports.MainNavigation = MainNavigation;